import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const mediaUrl = (u) =>
  !u ? null : u.startsWith("http") ? u : `${BACKEND_URL}${u}`;

// RELIABILITY (2026-09-16): no request timeout meant a hung backend/network
// path left the UI waiting indefinitely with no feedback. 30s is generous
// enough for real generation-status polling endpoints while still failing a
// truly stuck request in bounded time; it does not change behavior for any
// request that completes normally.
const api = axios.create({ baseURL: API, withCredentials: true, timeout: 30000 });

// When Clerk is active, AuthContext registers an async token getter here so
// every request carries a fresh Clerk session token. When Clerk is not
// active (legacy local email/password auth), no Bearer token is needed at
// all -- that session travels as an httpOnly cookie instead (see
// withCredentials: true above, and the interceptor below).
let clerkTokenGetter = null;
export const setClerkTokenGetter = (fn) => { clerkTokenGetter = fn; };

api.interceptors.request.use(async (config) => {
  // SECURITY (hardening gate Phase 20): this used to fall back to a
  // plain-text session token mirrored into localStorage ("vyom_token")
  // whenever no Clerk token getter was registered. That fallback served no
  // purpose this app actually needs: the legacy local-auth login flow's
  // real session already travels as an httpOnly cookie on every request
  // (see withCredentials: true above), and the backend checks that cookie
  // before ever looking at this header (core/security.py::
  // get_current_user) -- so removing it is a pure hardening, not a
  // capability loss. The Clerk path is untouched: a Clerk session has no
  // cookie set by this backend at all, so a real Bearer token from
  // clerkTokenGetter is still required and still attached below.
  let token = null;
  if (clerkTokenGetter) {
    try { token = await clerkTokenGetter(); } catch { token = null; }
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
